const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#63d1a2;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.966, -0.259, 0.259, 0.966, -4.328, 4.464)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.568 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.152 25.642)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M279.93,1264.78a1.081,1.081,0,0,0,.987-1.168l-.517-6.164a1.082,1.082,0,1,0-2.156.181l.518,6.164A1.081,1.081,0,0,0,279.93,1264.78Z",
  transform: "translate(-278.24 -1256.456)"
})), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M273.331,1186.149a1.081,1.081,0,0,0,.987-1.168l-.517-6.164a1.082,1.082,0,1,0-2.156.181l.517,6.164A1.081,1.081,0,0,0,273.331,1186.149Z",
  transform: "translate(-271.642 -1177.825)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 14.568)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.641)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M306.771,1225.176l6.164-.517a1.082,1.082,0,1,0-.181-2.156l-6.164.517a1.082,1.082,0,1,0,.181,2.156Z",
  transform: "translate(-305.598 -1222.499)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 2.152)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M228.14,1231.775l6.164-.518a1.082,1.082,0,1,0-.181-2.156l-6.164.517a1.082,1.082,0,0,0,.181,2.156Z",
  transform: "translate(-226.968 -1229.098)"
}))));
function SvgCruz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.948,
    height: 32.949,
    viewBox: "0 0 32.948 32.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruz);
export default __webpack_public_path__ + "static/media/cruz.df9a1bfdb5e030c17a871f459c363a8f.svg";
export { ForwardRef as ReactComponent };